import {Row} from "./row";

export class BlacklistRow extends Row {
  public value: string = "";
  public caseSensitive: boolean = false;
  public exactMatch: boolean = false;
  public wordMatch: boolean = false;
}
